'use strict';

(function () {
  'use strict';

  angular.module('msUtility').directive('msKeepFocusHere', msKeepFocusHere);

  msKeepFocusHere.$inject = ['$window', '$timeout', '$rootScope'];

  function msKeepFocusHere($window, $timeout, $rootScope) {
    var directive = {
      restrict: 'A',
      scope: {
        // (optional) function call that results in removing this directive
        // example: If a modal used this directive to keep the user's focus within the modal,
        // $ctrl.closeModal() hides the modal and removed it from the DOM.
        // Passing  $ctrl.closeModal in as the escFunc would cause the modal to be removed
        // when the user presses the 'esc' key.
        escFunc: '&',
        // (optional) a child of this element
        focusTarget: '@',
        // (optional) boolean. When false, eventListeners get removed and escFunc gets called.
        msKeepFocusHere: '='
      },
      link: link
    };

    var _focusableElements = 'a[href], button, select, input, textarea, [tabindex]';

    function link(scope, element) {
      // If a specific element is specified, keep the focus to that. Otheriwse, use this element.
      var container = scope.focusTarget ? element[0].querySelector(scope.focusTarget) : element[0];
      var previouslyFocusedElement = removeFocusFromEl($window.document.activeElement);
      var focusToEl = container.querySelector(_focusableElements);
      var eventListeners = [];

      scope.$watch('msKeepFocusHere', function (newVal) {
        if (!_.isUndefined(newVal) && !newVal) {
          // if msKeepFocusHere is set to false, clean up and go home (move focus back to previouslyFocusedElement).
          scope.escFunc();
          cleanup(previouslyFocusedElement, eventListeners);
        } else {
          // If msKeepFocusHere is undefined or true, move the focus and set of eventListeners.
          removeFocusFromEl($window.document.activeElement);
          moveFocusToEl(focusToEl);
          eventListeners = setUpListeners(container, focusToEl, scope);
          // When this directive is removed, clean up.
          scope.$on('$destroy', function () {
            cleanup(previouslyFocusedElement, eventListeners);
          });
        }
      });
    }

    function removeFocusFromEl(el) {
      if (el) {
        el.blur();
      }
      return el;
    }

    // Moved focus to an element. $timeout is necessary for some reason.
    // Either Angular timing or thread blocking would prevent focus from happening.
    function moveFocusToEl(el) {
      if (el) {
        $timeout(function () {
          el.focus();
        });
      }
      return el;
    }

    // Remove eventListeners and move focus back from whence it came.
    function cleanup(previouslyFocusedElement, arrayOfListenersToRemove) {
      removeFocusFromEl($window.document.activeElement);
      arrayOfListenersToRemove.forEach(function (listener) {
        $window.document.removeEventListener('focus', listener, true);
        $window.document.removeEventListener('keyup', listener, true);
      });
      moveFocusToEl(previouslyFocusedElement);
    }

    // Create 'keyup' and 'focus' eventListeners.
    // Returns said listeners so they can be removed later.
    function setUpListeners(containTo, focusTo, scope) {

      function _focusOnEl(event) {
        // Fix to let keyboard focus move inside Material select popup
        if ($rootScope.isSelectOpened) {
          return;
        }

        // If the focus target is or is a child of el, move focus to it.
        if (focusTo && (!containTo.contains(event.target) || event.target === containTo)) {
          focusTo.focus();
        }
      }

      function _escapeKeypress(event) {
        // let 'escape' key close Material select popup
        if ($rootScope.isSelectOpened) {
          return;
        }

        // if the key pressed was the 'escape' key, move focus back.
        if (event.keyCode === 27) {
          scope.escFunc();
        }
      }

      $window.document.addEventListener('focus', _focusOnEl, true);
      $window.document.addEventListener('keyup', _escapeKeypress, true);

      return [_focusOnEl, _escapeKeypress];
    }

    return directive;
  }
})();